module.exports = __webpack_public_path__ + "static/media/Shaman_Elemental.4b4e2313.png";